// Sustemia · Balance Hídrico · fichas de campo
// Puerto directo de casos-de-campo-v1.js — ver ese archivo original en
// client/Balance de agua/ para el detalle narrativo de cada caso.
//
// DATOS PUROS. Sin lógica de cálculo, sin acceso al DOM, sin dependencias.
// El motor (waterBalanceCalc.js) sigue siendo la única fuente de verdad para
// el cálculo: las memorias de cálculo de acá describen el método, no lo
// ejecutan.
//
// Los valores de `ejemplo` son DATOS DE DEMOSTRACIÓN (para mostrar la ficha
// antes de que el usuario cargue su propio caso). Los `metodo`, `fuenteId` y
// `gradoOtorgado` NO: salen de fuentes publicadas registradas en
// catalogs/fuentesIso690.js.

export const CASOS_DE_CAMPO = {
  A1_POZO_MACROMEDIDOR: {
    tipologia: "A_TELAS",
    nombre: "Extracción de pozo con macromedidor",
    yaEstaEnAgua: "La fuente, el volumen del período, el método, la frecuencia, el vencimiento de calibración y las evidencias.",
    hayQueConseguir: "El volumen autorizado del permiso, y a qué centro va el agua.",
    atajo: "Si Agua está al día, este caso es solo cargar el permiso. Se carga una vez, en el alta del pozo, y es lo único que habilita la alerta legal.",
    quien: ["mantenimiento", "sustentabilidad"],
    donde: "Cabezal del pozo. El permiso, en Legales",
    llevar: ["Celular", "Planilla de lectura", "Copia del permiso de extracción"],
    duracionMin: 5,
    recurrencia: "mensual",
    metodo: "medidor_dedicado",
    gradoOtorgado: 5,
    condicionesDeGrado: {
      5: "calibracion_vigente && lectura_mensual && evidencia_adjunta",
      4: "calibracion_vencida || lectura_trimestral",
    },
    memoriaDeCalculo: null, // lectura directa
    pasos: [
      "Foto del display del totalizador con fecha visible.",
      "Volumen del período = lectura final − lectura inicial.",
      "Adjuntar el certificado de calibración vigente. Sin certificado, el mismo dato baja de grado 5 a grado 4.",
      "Cargar el volumen autorizado del permiso una sola vez, en el alta del pozo.",
    ],
    validacionesQueDispara: [
      { id: "extraccion_supera_permiso", severidad: "alta", tipo: "legal" },
      { id: "extraccion_sobre_90pct_permiso", severidad: "media", tipo: "preventiva" },
    ],
    ejemplo: {
      esDemo: true,
      lecturaPeriodo_m3: 186400,
      volumenAutorizado_m3: 200000,
      usoDelPermiso_pct: 93.2,
      grado: 5,
    },
    erroresFrecuentes: [
      "Restar lecturas de medidores distintos después de un recambio, sin registrar el corte.",
      "Cargar el caudal nominal de la bomba en vez de la lectura.",
    ],
    fuenteId: "IWA_AWWA_M36",
  },

  A2_TORRE_POR_DIFERENCIA: {
    tipologia: "A_TELAS",
    nombre: "Evaporación en torre de enfriamiento, por diferencia",
    yaEstaEnAgua: "Nada.",
    hayQueConseguir: "Todo. Agua registra fuentes de ingreso, no submedición interna.",
    quien: ["mantenimiento"],
    donde: "Línea de reposición y línea de purga de la torre",
    llevar: [],
    duracionMin: 10,
    recurrencia: "mensual",
    metodo: "derivado_de_dos_mediciones",
    gradoOtorgado: 3,
    condicionesDeGrado: {
      3: "reposicion_medida && purga_medida",
      2: "falta_algun_medidor: usar estimador + memoria obligatoria",
    },
    memoriaDeCalculo: {
      formula: "EVAPORACION = REPOSICION_MEDIDA - PURGA_MEDIDA",
      derivados: { CICLOS_DE_CONCENTRACION: "REPOSICION_MEDIDA / PURGA_MEDIDA" },
      variables: ["REPOSICION_MEDIDA", "PURGA_MEDIDA"],
    },
    pasos: [
      "¿Hay medidor en la reposición? ¿Hay medidor en la purga?",
      "Si están los dos: evaporación = reposición − purga. No hay estimación, hay resta.",
      "Si falta alguno, usar el estimador (grado 2, memoria de cálculo obligatoria) y recomendar instalación en el plan de medición.",
    ],
    porQueGrado3: "El número no se lee de ningún instrumento. Un derivado de dos grados 5 es más defendible que una estimación de ingeniería, y menos que una lectura.",
    ejemplo: {
      esDemo: true,
      reposicionMedida_m3: 24600,
      purgaMedida_m3: 5900,
      evaporacion_m3: 18700,
      ciclosDeConcentracion: 4.17,
      grado: 3,
    },
    erroresFrecuentes: [
      "Contar la reposición como entrada y además la evaporación como salida sin restarla del circuito.",
      "Purga automática por conductividad sin totalizador: no es medición, es control.",
    ],
    fuenteId: "DOE_FEMP_BMP10",
  },

  A3_CALDERA_POR_DIFERENCIA: {
    tipologia: "A_TELAS",
    nombre: "Vapor perdido en caldera, por diferencia",
    yaEstaEnAgua: "Nada.",
    hayQueConseguir: "Todo. Agua registra fuentes de ingreso, no submedición interna de la caldera.",
    quien: ["mantenimiento"],
    donde: "Línea de reposición y línea de purga de la caldera",
    llevar: [],
    duracionMin: 10,
    recurrencia: "mensual",
    metodo: "derivado_de_dos_mediciones",
    gradoOtorgado: 3,
    condicionesDeGrado: {
      3: "reposicion_medida && purga_medida",
      2: "falta_algun_medidor: usar estimador + memoria obligatoria",
    },
    memoriaDeCalculo: {
      formula: "VAPOR_PERDIDO = REPOSICION_MEDIDA - PURGA_MEDIDA",
      variables: ["REPOSICION_MEDIDA", "PURGA_MEDIDA"],
    },
    pasos: [
      "¿Hay medidor en la reposición? ¿Hay medidor en la purga?",
      "Si están los dos: vapor perdido = reposición − purga. La purga vuelve al efluente y ya se mide ahí: no se cuenta dos veces.",
      "Si falta alguno, usar el estimador (grado 2, memoria de cálculo obligatoria) y recomendar instalación en el plan de medición.",
    ],
    porQueGrado3: "El número no se lee de ningún instrumento. Un derivado de dos grados 5 es más defendible que una estimación de ingeniería, y menos que una lectura.",
    ejemplo: {
      esDemo: true,
      reposicionMedida_m3: 12400,
      purgaMedida_m3: 2400,
      vaporPerdido_m3: 10000,
      grado: 3,
    },
    erroresFrecuentes: [
      "Contar la reposición como entrada y además el vapor perdido como salida sin restar la purga, que ya vuelve al efluente y se mide ahí.",
      "Purga automática por conductividad sin totalizador: no es medición, es control.",
    ],
    fuenteId: "DOE_FEMP_BMP10",
  },

  B1_MEDIDOR_COMPARTIDO: {
    tipologia: "B_ETIQUETAS",
    nombre: "Un medidor para tintura y sanitarios",
    yaEstaEnAgua: "La lectura del medidor con sus evidencias, la dotación y los días operativos.",
    hayQueConseguir: "El registro de cargas, la relación de baño de la ficha de proceso, los litros por persona-día.",
    atajo: "El estimador doméstico arranca resuelto en dos de sus tres variables: personas y días vienen del contexto, el usuario solo elige el litraje.",
    quien: ["sustentabilidad", "jefe_tintoreria", "rrhh"],
    donde: "Medidor de acometida · registro de cargas de tintura · planilla de personal",
    llevar: ["Fichas de proceso de tintura", "Dotación por turno del período"],
    duracionMin: 480,
    duracionRecurrenteMin: 30,
    recurrencia: "mensual",
    metodo: "totalizador_compartido",
    gradoOtorgado: 3, // el medidor. Los repartos derivados quedan en 2.
    reglaDura: "El medidor es el techo: ningún reparto puede superar la lectura.",
    memoriaDeCalculo: {
      formula: [
        "TINTURA = CARGAS * KG_POR_CARGA * RELACION_DE_BANO",
        "DOMESTICO = PERSONAS * DIAS_OPERATIVOS * LITROS_POR_PERSONA_DIA",
        "NO_ASIGNADO = MEDIDOR - TINTURA - DOMESTICO",
      ],
      variables: ["CARGAS", "KG_POR_CARGA", "RELACION_DE_BANO", "PERSONAS", "DIAS_OPERATIVOS", "LITROS_POR_PERSONA_DIA", "MEDIDOR"],
      fuentePorVariable: { RELACION_DE_BANO: "IFC_EHS_TEXTIL", LITROS_POR_PERSONA_DIA: "HOWARD_BARTRAM_OMS" },
    },
    pasos: [
      "Cargar la lectura del medidor compartido. Es el techo: ningún reparto puede superarlo.",
      "Cuantificar tintura desde el registro de cargas, con la relación de baño de la ficha de proceso.",
      "Cuantificar sanitarios y comedor con el estimador por persona-turno.",
      "Lo que sobra no se reparte: se carga como \"no asignado\".",
    ],
    bloqueaCierreSi: "no_asignado_sin_clasificar",
    clasificacionRequerida: "IWA_AWWA_M36",
    ejemplo: {
      esDemo: true,
      periodo: "mensual",
      medidor_m3: 380.0,
      tintura: { cargas: 180, kgPorCarga: 80, relacionDeBano_L_kg: 12, volumen_m3: 172.8 },
      domestico: { personas: 140, dias: 22, litrosPorPersonaDia: 40, volumen_m3: 123.2 },
      noAsignado_m3: 84.0,
      noAsignado_pct: 22.1,
    },
    erroresFrecuentes: [
      "Repartir el residuo a prorrata entre los usos conocidos para que \"cierre\".",
      "Usar la relación de baño nominal del equipo en vez de la de la ficha de proceso.",
      "Contar la dotación total en vez de la efectivamente presente.",
    ],
    fuenteId: "IFC_EHS_TEXTIL",
  },

  B2_VARIACION_INVENTARIO: {
    tipologia: "B_ETIQUETAS",
    nombre: "Variación de inventario en cisterna",
    yaEstaEnAgua: "Las fechas del período.",
    hayQueConseguir: "La geometría del tanque, los dos niveles y la referencia física.",
    atajo: "La geometría se carga una sola vez en el alta del tanque. A partir del segundo período, este caso son dos números y diez minutos.",
    quien: ["mantenimiento"],
    donde: "Cisterna o tanque elevado",
    llevar: ["Metro o sonda", "Dimensiones internas del tanque"],
    duracionMin: 10,
    recurrencia: "dos_veces_por_periodo",
    metodo: "medicion_geometrica",
    gradoOtorgado: 4,
    memoriaDeCalculo: {
      formula: [
        "AREA = PI * (DIAMETRO / 2)^2",
        "VOLUMEN = AREA * NIVEL",
        "DELTA_INVENTARIO = VOLUMEN_FINAL - VOLUMEN_INICIAL",
      ],
      variables: ["DIAMETRO", "NIVEL_INICIAL", "NIVEL_FINAL"],
      nota: "El motor opera con el valor completo. Nunca sobre valores ya redondeados.",
    },
    pasos: [
      "Medir el nivel el primer día del período, antes del primer turno.",
      "Medir el nivel el último día, en el mismo horario y con la misma referencia física.",
      "El motor calcula el volumen con la geometría cargada en el alta del tanque.",
    ],
    reglaDura: "El signo entra en la ecuación: Entradas = Salidas + Δ inventario.",
    ejemplo: {
      esDemo: true,
      diametro_m: 3.0,
      area_m2: 7.0686,
      nivelInicial_m: 2.4,
      volumenInicial_m3: 16.96,
      nivelFinal_m: 1.15,
      volumenFinal_m3: 8.13,
      deltaInventario_m3: -8.84,
    },
    erroresFrecuentes: [
      "Medir con la escalerilla un día y con la sonda otro.",
      "Cargar el volumen nominal del tanque como si fuera el contenido.",
      "Medir el nivel final el día 30 y el inicial del mes siguiente el día 2.",
    ],
    fuenteId: "UNEP_UNIDO_TR7",
  },

  C1_LAVANDERIA_RELACION_BANO: {
    tipologia: "C_PRODUCTO_TERMINADO",
    nombre: "Lavandería industrial por relación de baño",
    yaEstaEnAgua: "La producción del período.",
    hayQueConseguir: "Prendas procesadas, peso medio, relación de baño acumulada — y antes que nada, si hay medidor dedicado.",
    atajo: "Si Agua ya tiene un submedidor de lavandería declarado como fuente, este caso no se usa.",
    quien: ["jefe_lavanderia", "sustentabilidad"],
    donde: "Registro de producción de lavandería · fichas de proceso",
    llevar: ["Peso medio por prenda del período (no el de catálogo)"],
    duracionMin: 30,
    recurrencia: "mensual",
    metodo: "estimacion_ingenieria",
    gradoOtorgado: 2,
    preguntaBloqueante: { id: "existe_medidor_dedicado_lavanderia", siVerdadero: "usar_lectura_directa_grado_5" },
    condicionesDeGrado: { 2: "memoria_documentada", 1: "sin_memoria" },
    memoriaDeCalculo: {
      formula: [
        "KG_PROCESADOS = PRENDAS * PESO_MEDIO_POR_PRENDA",
        "VOLUMEN = KG_PROCESADOS * SUMA_RELACION_DE_BANO_DE_CADA_BANO",
      ],
      variables: ["PRENDAS", "PESO_MEDIO_POR_PRENDA", "SUMA_RELACION_DE_BANO_DE_CADA_BANO"],
      nota: "Sumar TODOS los baños del ciclo: lavado, enjuagues y suavizado.",
    },
    pasos: [
      "Antes que nada: ¿hay medidor dedicado en la lavandería? Si lo hay, este caso no se usa.",
      "Si no lo hay: prendas procesadas × peso medio = kg procesados.",
      "Sumar la relación de baño de todos los baños del ciclo de la ficha de proceso, no solo del principal.",
      "Cargar la memoria de cálculo. Es obligatoria: sin memoria el flujo cae a grado 1.",
    ],
    techoDeEstimacion: { umbralPct: 30, tipo: "umbral_interno_sustemia", accion: "prioriza_plan_de_medicion" },
    ejemplo: {
      esDemo: true,
      periodo: "mensual",
      prendas: 14400,
      pesoMedioPorPrenda_kg: 0.42,
      kgProcesados: 6048,
      relacionDeBanoAcumulada_L_kg: 20,
      volumen_m3: 120.96,
      grado: 2,
    },
    erroresFrecuentes: [
      "Contar solo el baño de lavado y olvidar enjuagues y suavizado.",
      "Usar el peso de catálogo de la prenda en vez de pesar una muestra del período.",
      "Estimar la lavandería teniendo medidor porque \"da más prolija\".",
    ],
    fuenteId: "IFC_EHS_TEXTIL",
  },

  C2_CIERRE_FACTURA_Y_TANQUE: {
    tipologia: "C_PRODUCTO_TERMINADO",
    nombre: "Cierre del período con factura y variación de tanque",
    yaEstaEnAgua: "Las facturas, con su período de consumo y sus evidencias adjuntas.",
    hayQueConseguir: "El efluente medido, las estimaciones de evaporación y riego, el Δ inventario.",
    atajo: "El error de tomar las facturas por fecha de emisión ya está resuelto aguas arriba: Agua guarda el período de consumo.",
    quien: ["sustentabilidad"],
    donde: "Facturas del prestador · medidor de efluente · cisterna",
    llevar: ["Todas las facturas del período, incluidas las estimadas por el prestador"],
    duracionMin: 480,
    recurrencia: "anual",
    metodo: "factura_proveedor",
    gradoOtorgado: 3,
    condicionesDeGrado: { 3: "consumo_real", 2: "consumo_estimado_por_prestador" },
    reglaDura: "Período de consumo, no fecha de emisión.",
    memoriaDeCalculo: {
      formula: "DESCUADRE = ENTRADAS - SALIDAS - DELTA_INVENTARIO",
      variables: ["ENTRADAS", "SALIDAS", "DELTA_INVENTARIO"],
    },
    pasos: [
      "Sumar las facturas cuyo período de consumo cae dentro del período del balance. No las de fecha de emisión.",
      "Marcar las facturas con consumo estimado por el prestador: bajan de grado 3 a grado 2.",
      "Cargar el efluente medido, las estimaciones de evaporación y riego, y el Δ inventario del caso B2.",
      "Leer el descuadre.",
    ],
    ejemplo: {
      esDemo: true,
      periodo: "anual",
      entradas: { red_municipal_m3: 1842 },
      salidas: { efluente_medido_m3: 1310, evaporacion_secado_planchado_m3: 210, riego_m3: 95, total_m3: 1615 },
      deltaInventario_m3: 6,
      descuadre_m3: 221,
      descuadre_pct: 12.0,
    },
    // El margen de cierre (10%) es el ÚNICO criterio del módulo sin fuente
    // publicada (ver Fuentes.md §2). No se presenta como umbral normativo.
    // El ejemplo (12%) queda deliberadamente por encima, para mostrar el
    // caso "hay que explicar la diferencia".
    notaMetodologica: "El margen de cierre del 10% es un criterio interno de Sustemia, no normativo, confirmado por el cliente. Se ofrece la incertidumbre propagada de los instrumentos como criterio alternativo y más defendible.",
    criterioAlternativo: "incertidumbre_propagada_de_instrumentos",
    erroresFrecuentes: [
      "Tomar las facturas por fecha de emisión.",
      "Ignorar el Δ inventario chico porque \"es chico\".",
      "Cargar el efluente como \"igual a la entrada menos un 10 %\".",
    ],
    fuenteId: "UNEP_UNIDO_TR7",
  },
};

// Orden de preguntas del formulario — no negociable. El campo de volumen
// permanece deshabilitado hasta que se declara el origen (ver Guía de campo §1.1).
export const ORDEN_DE_CARGA = [
  { paso: 1, pregunta: "¿De dónde sale este dato?", bloquea: "campo_volumen" },
  { paso: 2, pregunta: "¿Podés adjuntar la evidencia?", bloquea: "confirmacion" },
  { paso: 3, pregunta: "Confirmá el volumen y el grado derivados", editable: false },
];

export function casosDeTipologia(tipologiaId) {
  return Object.entries(CASOS_DE_CAMPO)
    .filter(([, caso]) => caso.tipologia === tipologiaId)
    .map(([id, caso]) => ({ id, ...caso }));
}

export default { CASOS_DE_CAMPO, ORDEN_DE_CARGA, casosDeTipologia };
